import React from 'react';
import { FiPlus } from 'react-icons/fi';

import {
  PageHeader,
  type PageHeaderAction,
} from '../../../../../components/PageHeader';

interface ChatListHeaderProps {
  onCreateChat: () => void;
}

export const ChatListHeader: React.FC<ChatListHeaderProps> = ({
  onCreateChat,
}) => {
  const pageActions: PageHeaderAction[] = [
    {
      label: 'Create Chat',
      icon: <FiPlus size={16} />,
      onClick: onCreateChat,
      color: 'primary',
    },
  ];

  return (
    <PageHeader
      title="Chats Management"
      description="Manage chat relationships between buyers and distributors"
      actions={pageActions}
    />
  );
};
